import { useNavigate } from 'react-router-dom'

const features = [
  'Dairy management dashboard',
  'Subscriber management',
  'Milk subscriptions',
  'Product management',
  'Delivery management',
  'Order management',
  'Email notifications',
  'Reports',
]

export default function PricingSection() {
  const navigate = useNavigate()

  return (
    <section id="pricing" className="mf-section mf-pricing">
      <div className="mf-container">
        <h2 className="mf-section-title mf-reveal">Simple Pricing. Built for Dairies.</h2>
        <p className="mf-section-subtitle mf-reveal">
          Transparent pricing with no hidden charges. Start with a free first month.
        </p>

        <div className="mf-pricing-grid">
          {/* Monthly */}
          <div className="mf-pricing-card mf-reveal">
            <h3>Monthly</h3>
            <div className="mf-pricing-price">
              <span className="amount">₹999</span>
              <span className="period">/ month</span>
            </div>

            <ul className="mf-pricing-features">
              {features.map((f, i) => (
                <li key={i}>
                  <span className="check">✓</span>
                  {f}
                </li>
              ))}
            </ul>

            <button className="mf-btn-pricing secondary" onClick={() => navigate('/login')}>
              Start Free
            </button>
          </div>

          {/* Yearly */}
          <div className="mf-pricing-card recommended mf-reveal" style={{ transitionDelay: '0.1s' }}>
            <div className="mf-pricing-badge">Best Value</div>
            <h3>Yearly</h3>
            <div className="mf-pricing-price">
              <span className="amount">₹10,000</span>
              <span className="period">/ year</span>
            </div>
            <div className="mf-pricing-save">Save ₹1,988/year</div>

            <ul className="mf-pricing-features">
              {features.map((f, i) => (
                <li key={i}>
                  <span className="check">✓</span>
                  {f}
                </li>
              ))}
            </ul>

            <button className="mf-btn-pricing primary" onClick={() => navigate('/login')}>
              Start Free
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
